<template>
    <div class="c-m-carousel" @mouseover="hoverEnter()" @mouseleave="hoverLeave()">
        <transition-group tag="div" class="c-m-carousel__inner" name="c-m-carousel__inner--animation">
            <div v-for="index in [start]" class="c-m-carousel__item" :key="`item-${index}`">
                <div v-for="(item, key) in chunkArray[index]" :key="`image-${key}`" class="c-m-carousel__image">
                    <img :alt="altText" :src="item" @click="openImg(item)" />
                </div>
            </div>
        </transition-group>
        <div v-if="chunkArray.length > 1" class="c-m-carousel__bullets">
            <li v-for="index in chunkArray.length" :key="index" @click="slideTo(index - 1)" class="c-m-carousel__bullet" :class="{ 'c-m-carousel__bullet--active' : (index - 1) == start }"></li>
        </div>
        <modal class="c-m-modal--small c-m-modal--image" :centerContent="true" v-if="showModal" @close="showModal = false">
            <img class="c-m-modal-carousal__img-content" :src="getImg" alt="Modal bild"/>
        </modal>
    </div>
</template>

<script>
    import Icon from '../atoms/AtomIcon.vue';
    import Modal from './MoleculeModal.vue'

    export default {
        data(){
            return {
                start: 0,
                interval: null,
                showModal: false,
                'img': null,
            }
        },
        components: {
            Icon,
            Modal,
        },
        props:{
            items:Array,
            itemsToShow:{
                default: 1,
                type: Number
            },
            altText: String,
            itemsToScroll: {
                default: 2,
                type: Number
            },
            autoPlay: {
                default: true,
                type: Boolean
            },
            playSpeed: {
                default: 4000,
                type: Number
            },
            isLatestRequests: {
                default: false,
                type: Boolean
            },
            isLatestCompanies: {
                default: false,
                type: Boolean
            },
            isTestimonial: {
                default: false,
                type: Boolean
            },
            isLatestRatings: {
                default: false,
                type: Boolean
            },
        },
        computed:{
            chunkArray: {
                get(){
                    let nrOfChunks = this.items.length / this.itemsToShow;
                    const arr = [];

                    for(let i = 0; i < nrOfChunks; i++){
                        let start = i * this.itemsToShow;
                        let end = start + this.itemsToShow;

                        arr.push(this.items.slice(start,end));
                    }
                    return arr;
                }
            },
            getImg: function() {
                return this.img
          }
        },
        mounted() {
            if(this.autoPlay){
                this.startCarousel();
            }
        },
        methods: {
            slideTo(index){
                this.start = index;
            },
            hoverEnter() {
                if(this.autoPlay){
                    this.stopCarousel();
                }
            },
            hoverLeave() {
                if(this.autoPlay){
                    this.startCarousel();
                }
            },
            startCarousel() {
                this.interval = setInterval(() => {
                    let newStart = this.start + 1;

                    if(newStart >= this.chunkArray.length){
                        newStart = 0;
                    }
                    this.start = newStart;
                }, this.playSpeed);
            },
            stopCarousel() {
                clearInterval(this.interval);
            },
            openImg: function(img){
            this.showModal = true;
            this.img = img;
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeCarousel.vue